module.exports = "<div\n  *ngIf=\"errorMessages.length\"\n  class=\"invalid-field-message\"\n>\n  <p *ngFor=\"let errorMessage of errorMessages\">\n    {{ errorMessage }}\n  </p>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /dist/src/app/shared/error-display/error-display.component.html
// module id = ../../../../../src/app/shared/error-display/error-display.component.html
// module chunks = main